import { Link } from "react-router-dom";
import { ArrowRight, Languages } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const LANG_LABELS = { en: "English", ml: "Malayalam", hi: "Hindi" };
const LANG_WORDS = { en: "english", ml: "malayalam", hi: "hindi" };

export const PodcastCard = ({ episode, i = 0 }) => {
  const firstLang = episode.available_languages[0];
  return (
    <Reveal delay={i * 60}>
      <Link
        to={`/podcasts/${episode.slug}/${LANG_WORDS[firstLang] || ""}`}
        data-testid={`podcast-card-${episode.slug}`}
        className="card-base group h-full flex flex-col overflow-hidden !p-0"
      >
        <div className="w-full h-44 bg-cts-charcoal overflow-hidden">
          {episode.cover_image ? (
            <img
              src={episode.cover_image}
              alt={episode.title}
              loading="lazy"
              className="w-full h-full object-cover"
              data-testid={`podcast-card-image-${episode.slug}`}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-white/40 font-heading font-bold text-xs uppercase">
              CTS Podcast
            </div>
          )}
        </div>
        <div className="p-6 flex flex-col flex-1">
          <div className="flex items-center gap-2 text-xs font-heading font-bold uppercase tracking-wide text-cts-red mb-2">
            <span>Episode {episode.episode_number}</span>
          </div>
          <h4 className="font-heading font-bold text-lg text-cts-ink mb-2">{episode.title}</h4>
          {episode.description && (
            <p className="text-[15px] leading-relaxed text-cts-charcoal flex-1 line-clamp-3">{episode.description}</p>
          )}
          <div className="flex items-center gap-1.5 mt-4 text-xs text-cts-charcoal/70">
            <Languages size={13} />
            {episode.available_languages.map((l) => LANG_LABELS[l]).join(" · ")}
          </div>
          <span className="link-arrow mt-3">LISTEN NOW <ArrowRight size={15} /></span>
        </div>
      </Link>
    </Reveal>
  );
};
